<template>
  <div class="show-more">
    <base-button v-if="hasCars" @click.native="showMoreCars">{{
      $t("search.show-more", { leftCarsCount: getCarsLeftCount })
    }}</base-button>
  </div>
</template>

<script>
import BaseButton from "@/components/ui/BaseButton/BaseButton.vue";
import { mapState } from "vuex";
import { GET_MORE_CARS } from "@/store/actionTypes";
import { INCREMENT_PAGE } from "@/store/mutationTypes";
import { options } from "@/store/options";

export default {
  name: "ShowMoreButton",
  components: {
    BaseButton
  },
  computed: {
    ...mapState(["search", "carCount", "results"]),
    getCarsLeftCount() {
      const carsPerPage = options.getCarsPerPage();
      const carsLeft = this.carCount - this.results.currentPage * carsPerPage;

      return carsLeft > 0 ? `(${carsLeft})` : "(0)";
    },
    hasCars() {
      return this.results.nextPage !== null;
    }
  },
  methods: {
    showMoreCars() {
      this.$store.commit(INCREMENT_PAGE);
      this.$store.dispatch(GET_MORE_CARS);
    }
  }
};
</script>

<style lang="scss" scoped>
.show-more {
  padding: 25px 20px;
  background-color: $color-white;
  z-index: $z-index-3;
}

@media screen and (min-width: $media-l) {
  .show-more {
    padding: 0 20px 50px 20px;
  }
}
</style>
